<template>
	<div
		data-component="section-header"
		:data-inverse="inverse"
		:data-modal-header="modalHeader"
		:data-borderbottom="borderBottom"
	>
		<h2
			v-font-style="$store.getters['ui/getHeadingFontDetail']"
			v-color="$store.getters['ui/getPrimaryColor']"
			data-element="text"
			:data-size="size"
			:data-inverse="inverse"
		>
			{{ text }}
		</h2>
	</div>
</template>

<script>
	export default {
		props: [ 'text', 'size', 'inverse', 'modalHeader', 'borderBottom' ]
	}
</script>

<style lang="scss">

	@import '@/assets/scss/variables.scss';
	@import '@/assets/scss/helpers.scss';

	[data-component='section-header'] {
		background:transparent;
		display:flex;
		align-items:center;
		justify-content:center;
		padding:16px;
		width:100%;
		&[data-modal-header] {
			padding-top:28px;
			@include whenScreenIs(sm) {
				padding-top:32px;
			}
			@media only screen and (max-height: 535px) {
				padding:8px;
			}
		}
		&:not([data-modal-header]) {
			@include whenScreenIs(sm) {
				padding:24px;
			}
		}
		&[data-borderbottom] {
			@include whenScreenIs(md) {
				border-bottom:1px solid $white-two;
			}
		}
		[data-element='text'] {
			width:70%;
			color:#fff;
			font-size:20px;
			font-weight:900;
			line-height:1.2;
			text-align:center;
			@include whenScreenIs(sm) {
				font-size:24px;
				width:328px;
			}
			&[data-inverse] {
				color:$pinkish-red;
			}
			&[data-size='sm'] {
				font-size:20px;
				@include whenScreenIs(sm) {
					width:432px;
				}
			}
			&[data-size='md'] {
				font-size:20px;
				width:280px;
				@include whenScreenIs(sm) {
					width:432px;
				}
			}
			&[data-size='lg'] {
				font-size:22px;
				line-height:24px;
				width:100%;
			}
		}
	}
</style>
